
import Call, { Methods } from './Call';

// Headers
const BodyHeaders = {
  'Content-Type': 'application/json; charset=UTF-8',
};

const AcceptHeaders = {
  Accept: 'application/json; charset=utf-8',
  'Accept-Charset': 'utf-8',
};

async function tryParseJsonOnNetworkError( error) {
  try {
    if( error.json) error = await error.json();
  } catch( metaError) {
    console.error( new Date(), 'helpers::Network::Json::tryParseJsonOnNetworkError - metaError: ', metaError);
  };
  throw error;
}

export default async function JsonCall( url, fetchOptions = {}, { expectedResponse } = {}) {
  const BodiedMethods = [ Methods.POST, Methods.PUT ];
  try {
    if( !fetchOptions) fetchOptions = {};
    if( !fetchOptions.headers) fetchOptions.headers = {};
    if( expectedResponse === undefined) expectedResponse = fetchOptions.method !== Methods.HEAD;
    if( expectedResponse) fetchOptions.headers = { ...AcceptHeaders, ...fetchOptions.headers };
    if( BodiedMethods.indexOf(fetchOptions.method) > -1) {
      fetchOptions.headers = { ...BodyHeaders, ...fetchOptions.headers };
      if( !fetchOptions.body) fetchOptions.body = {};
      fetchOptions.body = JSON.stringify(fetchOptions.body);
    }
    const response = await Call( url, fetchOptions).catch( tryParseJsonOnNetworkError);
    return response.status !== 204 ? response.json() : {};
  } catch (error) {
    console.error( new Date(), 'helpers::Network::Json - error: ', error);
    throw error;
  }
}
JsonCall.head = (url, fetchOptions, callOptions) => JsonCall( url, { ...fetchOptions, method: Methods.HEAD }, callOptions);
JsonCall.get = (url, fetchOptions, callOptions) => JsonCall( url, { ...fetchOptions, method: Methods.GET }, callOptions);
JsonCall.post = (url, fetchOptions, callOptions) => JsonCall( url, { ...fetchOptions, method: Methods.POST }, callOptions);
JsonCall.put = (url, fetchOptions, callOptions) => JsonCall( url, { ...fetchOptions, method: Methods.PUT }, callOptions);
JsonCall.delete = (url, fetchOptions, callOptions) => JsonCall( url, { ...fetchOptions, method: Methods.DELETE }, callOptions);
